import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@/environments/environment';
import { ApiResponse } from '@/app/models/api-response';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private readonly http = inject(HttpClient);
  private readonly endpoint: string = `${environment.apiEndpoint}/Auth`;

  exchange_token(idToken: string): Observable<ApiResponse<TokenResult>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${idToken}`
    });
    return this.http.post<ApiResponse<TokenResult>>(`${this.endpoint}/exchange-token`, {}, { headers });
  }

  login(email: string, password: string): Observable<ApiResponse<TokenResult>> {
    return this.http.post<ApiResponse<TokenResult>>(`${this.endpoint}/login`, { email, password });
  }

}